export enum ComplianceQuestionType {
    Before = 'Before',
    During = 'During',
    After = 'After',
    Requirement = 'Requirement'
}
